import React from "react";
interface IconUserProps {
  className?: string;
  width?: number;
  height?: number;
}

const IconUser: React.FC<IconUserProps> = ({ className, width, height }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="21"><path fill="#D9D9D9" d="M0 .77h20v20H0z" /></mask><g mask="url(#a)"><path d="M6.667 12.437h6.666v-.458q0-.918-.916-1.48Q11.5 9.937 10 9.937t-2.417.562-.916 1.48zM10 9.104q.687 0 1.177-.49t.49-1.177-.49-1.177A1.6 1.6 0 0 0 10 5.77q-.687 0-1.177.49t-.49 1.177.49 1.177 1.177.49m-8.333 10v-15q0-.688.49-1.178.489-.49 1.176-.49h13.334q.687 0 1.177.49t.49 1.178v10q0 .687-.49 1.177t-1.177.49H5zm2.625-5h12.375v-10H3.333V15.04z" fill="#1C1B1F" /></g></svg>
);
export default IconUser;
